PJQ.notifications = {
	createNotifyModal: function (options) {
		if (options.cookie == null || !PJQ.helpers.cookieHelpers.getCookie(options.cookie)) {
			new PJQ.notifications.NotifyModal(options);
			return true;
		}
		return false;
	}
};

PJQ.notifications.NotifyModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Notify')
	},
	events: {
		"click .btn-dont-show": "setDontShowCookie"
	},
	setDontShowCookie: function () {
		if (_.size(this.options.cookie) > 0) {
			PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true);
		}
	}
});

PJQ.notifications.notify = {
	defaultNotifySettings: {
		placement: {
			from: 'bottom',
			align: 'right'
		},
		animate: {
			enter: 'animated fadeInDown',
			exit: 'animated fadeOutRight'
		},
		allow_dismiss: true,
		delay: 5000,
		z_index: 10000000
	},
	getTemplate: function (options, callback) {
		PJQ.templating.TemplateRenderer.parseTemplate(new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Notify'), options, function (template) {
			callback(template.outerHTML());
		});
	},
	notify: function (options, settings) {
		let notifyOptions = {},
			notifySettings = {};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = options;
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object') {
			notifySettings = _.defaults(settings, this.defaultNotifySettings);
		}

		this.getTemplate({ options: notifyOptions, settings: notifySettings }, function ($template) {
			notifySettings.template = $template;
			$.notify(notifyOptions, notifySettings);
		});
	},
	successNotify: function (options, settings) {
		let notifyOptions = {
				icon: 'fal fa-check'
			},
			notifySettings = {
				type: 'notify-success'
			};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = _.defaults(options, notifyOptions);
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object') {
			notifySettings = _.defaults(settings, notifySettings);
		}

		this.notify(notifyOptions, notifySettings);
	},
	warningNotify: function (options, settings) {
		let notifyOptions = {
				icon: 'fal fa-lightbulb'
			},
			notifySettings = {
				type: 'notify-warning'
			};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = _.defaults(options, notifyOptions);
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object') {
			notifySettings = _.defaults(settings, notifySettings);
		}

		this.notify(notifyOptions, notifySettings);
	},
	errorNotify: function (options, settings) {
		let notifyOptions = {
				icon: 'fal fa-exclamation-triangle',
				title: 'Something went wrong!'
			},
			notifySettings = {
				type: 'notify-error'
			};

		if (PJQ.helpers.objectHelpers.refinedType(options) === 'object')
			notifyOptions = _.defaults(options, notifyOptions);
		if (PJQ.helpers.objectHelpers.refinedType(settings) === 'object')
			notifySettings = _.defaults(settings, notifySettings);

		this.notify(notifyOptions, notifySettings);
	}
};